import React from "react";
import { Button, Stack } from "@mui/material";
import _ from "lodash";
import Topbar from "../navigation/topBar";
import "../index.css";
import ContextBuilder from "./context_builder_dark";
import "./context_dark.css";
import ImageAnalysisViewer from "./imageAnalysisViewer";
// import StickyButton from "../ImageViewer/StickyButton";

export default function Context({ toggleComponent }) {
  return (
    <Stack sx={{ backgroundColor: "rgba(255, 255, 255)", minHeight: "100vh" }}>
      <Topbar
        logo="Constems-AI"
        title={"Context Module"}
        user={sessionStorage.getItem("user")}
        user_icon={true}
      />
      <div className="container_styles">
        <Stack direction="row" spacing={2} sx={{ marginTop: "4rem" }}>
          {/* Context builder Component */}
          <ContextBuilder />
          <ImageAnalysisViewer />
        </Stack>
        {/* <div
          style={{
            position: "fixed",
            bottom: 0,
            paddingBottom: "10px",
            left: "10px",
            zIndex: 1000,
          }}
        >
          <Button
            variant="contained"
            color="primary"
            onClick={() => toggleComponent("imagesTab")}
            sx={{ borderRadius: "50px" }}
          >
            Image Viewer
          </Button>
        </div> */}
        {/* <StickyButton content="Image Viewer" toggleComponent={toggleComponent} toggleContent="imagesTab" /> */}
      </div>
    </Stack>
  );
}
